export enum LanguageCodes {
    FRENCH ='fr',
    ENGLISH = 'en',
    DEUTSCH = 'de',
    DEFAULT = 'de'
}

export const LANGUAGE_OPTIONS = [
    {
      code: LanguageCodes.ENGLISH,
      label: 'common:profile.english',
      shortLabel: 'EN',
    },
    {
      code: LanguageCodes.DEUTSCH,
      label: 'common:profile.deutsch',
      shortLabel: 'DE',
    },
    {
      code: LanguageCodes.FRENCH,
      label: 'common:profile.french',
      shortLabel: 'FR',
    },
  ];